import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsPanelContentPeopleListWireframe from './VeltNotificationsPanelContentPeopleListWireframe/VeltNotificationsPanelContentPeopleListWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltNotificationsPanelContentPeopleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentPeopleWireframe.List = VeltNotificationsPanelContentPeopleListWireframe;
export default VeltNotificationsPanelContentPeopleWireframe;
